<div *ngIf="options.showCallToAcion" [className]="getClass()">
    <button class="order" (click)="onClickCallToAction()" mat-flat-button color="primary">{{ ( options.canBuy ? "button.getOfferBuy" : "button.getOffer" ) | translate}}</button>
    <button *ngIf="options.canDownloadOBX" (click)="obxDownloadAction.do()" mat-flat-button color="primary">{{ "button.obx" | translate}}</button>
</div>